module.exports = __webpack_public_path__ + "CFE - copia.png?6dc4abea6b426a590379da0685212f26";


//////////////////
// WEBPACK FOOTER
// ./images/icons/CFE - copia.png
// module id = 772
// module chunks = 0